/* assets/aos-stable-init.js */
/**
 * Устойчивая инициализация AOS
 *  - гарантирует работу с lazy-img внутри <image-element>
 *  - поддерживает горизонтальный скролл (миниатюры)
 *  - обновляет AOS при подгрузке новых картинок
 *  - «пинает» лениовые виджеты (Junip) чтобы они отрисовывались без скролла
 */
(function () {
  // --- 1) Запускаем AOS
  function initAOS() {
    if (!window.AOS || typeof AOS.init !== 'function') return;
    AOS.init({
      offset: 150,
      duration: 400,
      easing: 'ease',
      once: true,
      startEvent: 'load',
      disableMutationObserver: true
    });
  }

  // --- 2) Дебаунс
  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  // --- 2.1) «Пинаем» ленивые виджеты (Junip и т.п.), которые слушают resize/scroll
  function pokeLazyWidgets() {
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 80);
    });
  }

  // --- 3) Безопасный refresh
  var safeRefresh = debounce(function (hard) {
    if (!window.AOS) return;
    try {
      if (hard && typeof AOS.refreshHard === 'function') {
        AOS.refreshHard();
      } else if (typeof AOS.refresh === 'function') {
        AOS.refresh();
      }
    } catch (e) {}
  }, 60);

  // --- 4) Добавляем недостающие атрибуты
  function ensureAttrs(root) {
    var nodes = (root || document).querySelectorAll('image-element[data-aos], img[data-aos]');
    nodes.forEach(function (el) {
      if (!el.classList.contains('aos-init')) el.classList.add('aos-init');
      if (!el.hasAttribute('data-aos-offset')) el.setAttribute('data-aos-offset', '150');
    });
  }

  // --- 5) IntersectionObserver для горизонтальных списков
  function setupThumbsObserver() {
    if (!('IntersectionObserver' in window)) return;

    var containers = document.querySelectorAll('.product__thumbs--scroller');
    if (!containers.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          entry.target.classList.add('aos-animate');
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: [0, 0.01] });

    containers.forEach(function (wrap) {
      wrap.querySelectorAll('image-element[data-aos], img[data-aos]').forEach(function (el) {
        io.observe(el);
      });

      // Обновляем при скролле
      wrap.addEventListener('scroll', debounce(function () {
        safeRefresh(false);
      }, 60), { passive: true });

      // Обновляем при появлении новых thumbs
      var mo = new MutationObserver(debounce(function () {
        ensureAttrs(wrap);
        wrap.querySelectorAll('image-element[data-aos], img[data-aos]').forEach(function (el) {
          io.observe(el);
        });
        safeRefresh(true);
      }, 60));
      mo.observe(wrap, { childList: true, subtree: true });
    });
  }

  // --- 6) Перерисовка при загрузке изображений
  function wireImageLoadRefresh() {
    var all = document.querySelectorAll('image-element[data-aos], img[data-aos]');
    all.forEach(function (node) {
      var target = node.tagName === 'IMAGE-ELEMENT' ? node.querySelector('img') : node;
      if (!target) return;
      if (!(target.complete && target.naturalWidth > 0)) {
        target.addEventListener('load', function () {
          safeRefresh(false);
        }, { once: true });
      }
    });
  }

  // --- 6.1) Вотчер Junip — дергает «пинок» и AOS при появлении/обновлении блока отзывов
  var junipMO;
  function watchJunip() {
    if (typeof MutationObserver === 'undefined') return;
    if (junipMO) return; // уже запущен

    var sel = '.junip-review-section, .junip-reviews-container, [id^="junip"], [class*="junip-"]';

    // если уже есть на странице — сразу «пнуть» и обновить AOS
    if (document.querySelector(sel)) {
      pokeLazyWidgets();
      safeRefresh(true);
    }

    junipMO = new MutationObserver(debounce(function () {
      if (document.querySelector(sel)) {
        pokeLazyWidgets();
        safeRefresh(true);
      }
    }, 60));

    junipMO.observe(document.documentElement, { childList: true, subtree: true });
  }

  // --- 7) Интеграция с событиями Shopify / темы
  function wireThemeEvents() {
    document.addEventListener('shopify:section:load', function () {
      ensureAttrs(document);
      safeRefresh(true);
      setupThumbsObserver();
      watchJunip();        // NEW
      pokeLazyWidgets();   // NEW
      wireImageLoadRefresh();
    });

    ['product:media:ready', 'gallery:updated', 'variant:images:updated'].forEach(function (ev) {
      document.addEventListener(ev, function () {
        ensureAttrs(document);
        safeRefresh(true);
        setupThumbsObserver();
        watchJunip();      // NEW
        pokeLazyWidgets(); // NEW
        wireImageLoadRefresh();
      });
    });
  }

  // --- 8) Старт
  function boot() {
    initAOS();
    ensureAttrs(document);
    setupThumbsObserver();
    wireImageLoadRefresh();
    watchJunip();        // NEW
    pokeLazyWidgets();   // NEW
    wireThemeEvents();

    window.addEventListener('load', function () {
      safeRefresh(true);
      pokeLazyWidgets(); // NEW
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
